import { Typography, useTheme } from '@hmsexp/component-library';
import React from 'react';
import { View, FlatList } from 'react-native';
import { topicItemStyling } from './style';
import { TouchableOpacity } from '../react-native-components';

const TopicItem = props => {
  const { title, data, colorRules, onTopicClick } = props;
  const theme = useTheme();
  const styles = topicItemStyling(theme);

  function getImpactColor(value) {
    const range = colorRules.ranges.find(r => value >= r.min && value <= r.max);
    return range ? range.color : '#ffffff';
  }

  const renderItem = ({ item }) => {
    return (
      <View style={styles.itemContainer}>
        <View style={styles.itemContainerItem1}>
          <TouchableOpacity onPress={() => onTopicClick(item?.topic_filter_query)}>
            <Typography variant='button' fontWeightType='regular' color='hyperlinkBackgroundHigh'>
              {item?.topic_label}
            </Typography>
          </TouchableOpacity>
        </View>
        <View style={[styles.itemContainerItem2, { backgroundColor: getImpactColor(item?.impact_score) }]}>
          <Typography variant='subtitle1' fontWeightType='bold'>
            {item?.impact_score}
          </Typography>
        </View>
      </View>
    );
  };
  return (
    <View>
      <FlatList data={data} renderItem={renderItem} />
    </View>
  );
};
export default TopicItem;
